import React from 'react';
import { NamedLink } from '../../../components';
import { createSlug } from '../../../util/urlHelpers';
import { draftSlug } from '../../../routing/routeConfiguration';
import { formatBlogPublishDate, getBlogData } from '../../../util/dataExtractors';
import { convertBlogMarkdownToReact, isArrayLength } from '../../../util/genericHelpers';
import classNames from 'classnames';

import css from '../BlogPage.module.css';

function BlogCard(props) {
  const { isPatientBlogCard, isMenopauseBlogCard } = props;
  const { blog } = props;
  const { title = '', description = '', image, tag } = getBlogData(blog) || {};
  const publishDate = formatBlogPublishDate(blog);

  // Parse the description, stripping bold markers and truncating to 22 words
  const parsedDescription = convertBlogMarkdownToReact(description, true, 22);

  if (isMenopauseBlogCard) {
    return (
      <NamedLink
        className={classNames(css.blog, {
          [css.menopauseBlogCard]: isMenopauseBlogCard,
        })}
        name="SingleBlogPage"
        params={{ id: blog?.id, slug: blog?.attributes?.slug || createSlug(title || draftSlug) }}
        style={{ backgroundImage: `url(${image})` }}
      >
        <p />
      </NamedLink>
    );
  }

  return (
    <NamedLink
      className={classNames(css.blog, {
        [css.patientBlogCard]: isPatientBlogCard,
      })}
      name="SingleBlogPage"
      params={{ id: blog?.id, slug: blog?.attributes?.slug || createSlug(title || draftSlug) }}
    >
      <div
        className={classNames(css.blogImg, {
          [css.patientBlogCardImg]: isPatientBlogCard,
        })}
      >
        {image && <img src={image} alt={title} />}
      </div>
      <div className={css.blogDetails}>
        {publishDate ? (
          <div className={css.blogPostTime}>
            <span className={css.blogTime}>{publishDate}</span>
          </div>
        ) : null}
        <h2 className={css.blogPostTitle}>{title}</h2>
        {isArrayLength(tag) ? (
          <div className={css.tags}>
            {tag?.map((t, i) => (
              <span key={i}>#{t} </span>
            ))}
          </div>
        ) : null}

        {/* Render description as plain text */}
        <p className={css.blogPostDescription}>{parsedDescription}</p>
      </div>
    </NamedLink>
  );
}

export default BlogCard;
